import React from "react";
import "./Login.css";
import { Button, Form, Input, Spin, message, Checkbox } from "antd";
import logoBota from "../../assets/img/Frame.png";
import backgroundLogo from "../../assets/img/backgroundLogo.jpg";
import {
  LoadingOutlined,
} from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { checkLogin } from "../../redux/Login/Login";
import { settings, clearRedirect401Flag } from "../../utils/config";

export default function Login() {
  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 24,
      }}
      spin
    />
  );
  const { isLoadLogin } = useSelector((state) => state.persistedReducer.Login);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const onFinish = async (values) => {
    const data = {};
    data.email = values.email;
    data.password = values.password;

    try {
      // Dispatch action và lấy kết quả action object (bỏ unwrap để debug an toàn hơn)
      const actionResult = await dispatch(checkLogin(data));
      // Lấy payload từ action (nếu action lỗi hoặc không trả về gì, payload sẽ undefined)
      const payload = actionResult.payload;

      // Backend trả về cấu trúc { data: { status: 200, ... }, type: "bearer" } khi thành công
      // Hoặc { message: "Login failed" } khi thất bại
      // Ta lấy data từ payload.data (thành công) hoặc dùng chính payload (thất bại)
      const responseData = payload?.data || payload;

      if (responseData?.status === 200 && responseData?.access_token) {
        // user_token: backend Set-Cookie HttpOnly; không set từ FE
        settings.setCookie("user_idw", responseData.web_id, 365);
        clearRedirect401Flag();
        navigate("/loadata");
      } else {
        const errorMsg = responseData?.error || responseData?.message || "Đăng nhập thất bại (Không có phản hồi từ server)";
        message.error(errorMsg);
      }
    } catch (error) {
      message.error("lỗi dữ liệu");
    }
  };
  return (
    <>
      <div
        className='login'
        style={{
          backgroundImage: `url(${backgroundLogo})`,
          backgroundAttachment: "fixed",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center bottom",
          backgroundSize: "cover",
          minHeight: "100vh",
          padding: "40px 16px 24px",
          display: "flex",
          flexWrap: "wrap",
          alignContent: "space-between",
          justifyContent: "center",
        }}
      >
        <div className='login-inner'>
          <div className='login-card'>
            <div className='login-card-body'>
              {isLoadLogin && (
                <div className='login-spin-overlay'>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12 }}>
                    <Spin indicator={antIcon} />
                    <span className="login-loading-text">Đang đăng nhập...</span>
                  </div>
                </div>
              )}
              <div className='login-header'>
                <a href='/' className='login-logo'>
                  <img src={logoBota} alt='Bota' />
                </a>
                <h1 className='login-title'>Đăng nhập vào hệ thống</h1>
              </div>
              <div className='login-form-wrap'>
                <Form name='normal_login' onFinish={onFinish}>
                  <Form.Item
                    style={{ marginBottom: "15px" }}
                    name='email'
                    rules={[
                      {
                        required: true,
                        message: "Email không được để trống",
                      },
                    ]}
                  >
                    <Input
                      className='login-input'
                      placeholder='Email'
                      autoComplete='email'
                    />
                  </Form.Item>
                  <Form.Item
                    style={{ marginBottom: "10px" }}
                    name='password'
                    rules={[
                      {
                        required: true,
                        message: "Mật khẩu không được để trống",
                      },
                    ]}
                  >
                    <Input.Password
                      className='login-input'
                      type='password'
                      placeholder='Mật khẩu'
                      autoComplete='current-password'
                    />
                  </Form.Item>
                  <div className='login-options'>
                    <Form.Item
                      style={{ margin: 0 }}
                      name='remember'
                      valuePropName='checked'
                    >
                      <Checkbox className='login-remember'>Ghi nhớ đăng nhập</Checkbox>
                    </Form.Item>
                    <a
                      className='forgot-password'
                      href='/'
                      onClick={(e) => e.preventDefault()}
                    >
                      Quên mật khẩu ?
                    </a>
                  </div>
                  <Form.Item>
                    <Button
                      type='primary'
                      htmlType='submit'
                      className='login-form-button'
                    >
                      Đăng nhập
                    </Button>
                  </Form.Item>
                  <div className='login-footer-link'>
                    <a
                      className='create-acc'
                      href='https://aff.bota.vn/embed-register?service=/&nxtref=&aff_url=undefined&ref_mkt'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Tạo tài khoản ngay
                    </a>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
        <footer className='login-page-footer'>
          <div className='login-page-footer-inner'>
            <div className='login-page-copyright'>
              Copyright © 2023 bota.vn — connect.mybota.vn · Giải pháp quản lý và bán hàng đa kênh toàn diện
            </div>
            <div className='login-page-links'>
              <a href='/privacy-policy' target='_blank' rel='noopener noreferrer'>Chính sách quyền riêng tư</a>
              <a href='/terms-of-service' target='_blank' rel='noopener noreferrer'>Điều khoản dịch vụ</a>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}
